import { Pipe, PipeTransform } from '@angular/core';
import { Logger } from '@df/core/service/logger';
import { IAddressData } from '@df/session/api/address-book/address';

@Pipe({
    name: 'addressName'
})
export class AddressNamePipe implements PipeTransform {
    constructor(private logger: Logger) {}

    transform(addressData: IAddressData) {
        if (addressData) {
            return addressNamePipe(addressData);
        }
        this.logger.error('Address data is not defined for AddressNamePipe', this);
        return '';
    }
}

export function addressNamePipe(addressData: IAddressData) {
    const name = [addressData.prefix, addressData.firstname, addressData.lastname].filter(i => !!i).join(' ');
    return addressData.nickname ? `${name} (${addressData.nickname})` : name;
}
